import React, { useEffect, useState } from 'react';
import { PopupPremium } from 'components/Common';
import getGettyAbstractProduct from 'store/studioSearch/selector/getGettyAbstractProduct';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AvailablePopups } from 'store/app/types';
import { Product } from 'store/studioSearch/types';
import isDesktop from 'store/app/selector/isDesktop';
import ProductSelectPopupMobile from './Mobile/ProductSelectPopupMobile';
import styles from './ProductSelectPopup.module.scss';

const ProductSelectPopup = () => {
  const { t } = useTranslation();
  const gettyAbstractProduct = useSelector(getGettyAbstractProduct);
  const [selectedProductId, setSelectedProductId] = useState<number>();
  const [followUrl, setFollowUrl] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isDesktopDevice = useSelector(isDesktop);

  const handleProductTypeClick = (product: Product) => {
    setSelectedProductId(product.productId);
    setFollowUrl(product.followUrl);
  };

  const routeToFollowUrl = () => {
    if (followUrl) {
      window.location.href = followUrl;
    }
  };

  useEffect(() => {
    if (gettyAbstractProduct?.products.length === 0) {
      window.location.href = gettyAbstractProduct.redirectUrl;
      setIsLoading(false);
    } else if (gettyAbstractProduct) {
      handleProductTypeClick(gettyAbstractProduct.products[0]);
      setIsLoading(false);
    }
  }, [gettyAbstractProduct]);

  if (isLoading) {
    return null;
  }

  return (
    <PopupPremium
      popupId={AvailablePopups.studioProductSelectionPopup}
      title={t('txt_getty_abstract_product_type').toUpperCase()}
      showCloseIcon
    >
      {isDesktopDevice ? (
        <div className={styles.popup}>
          <div className={styles.row}>
            {gettyAbstractProduct?.products.map((product, index) => (
              <div key={`p${index}`} className={cn(styles.productType)} onClick={() => handleProductTypeClick(product)}>
                <div className={cn(styles.preview, { [styles.active]: product.productId === selectedProductId })}>
                  <img src={product.illustrationUrl} alt="Illustration" />
                </div>
                <div className={styles.details}>
                  <div className={styles.productTypeName}>{product.name}</div>
                  <div className={styles.description}>{product.description}</div>
                  <div className={styles.priceLine}>
                    <span>{t('txt_from')}&nbsp;</span>
                    {product.finalPrice.value !== product.initialPrice.value && (
                      <>
                        <span
                          className={styles.initialPrice}
                          dangerouslySetInnerHTML={{ __html: product.initialPrice.formatted }}
                        />
                        <span
                          className={styles.dicountedPrice}
                          dangerouslySetInnerHTML={{ __html: product.finalPrice.formatted }}
                        />
                      </>
                    )}
                    {product.finalPrice.value === product.initialPrice.value && (
                      <span dangerouslySetInnerHTML={{ __html: product.finalPrice.formatted }} />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.row}>
            <button className={styles.editBtn} onClick={() => routeToFollowUrl()}>
              {t('txt_edit')}
            </button>
          </div>
        </div>
      ) : (
        <ProductSelectPopupMobile publicAssetAbstractProduct={gettyAbstractProduct} />
      )}
    </PopupPremium>
  );
};

export default ProductSelectPopup;
